exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rednao .singleentry.rntable-striped tbody tr:nth-of-type(odd) {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.rednao .rntable-striped tbody tr:nth-of-type(even) {\r\n    background-color: white !important;\r\n}\r\n\r\n.singleentry td,.singleentry th{\r\n    padding:10px !important;\r\n}\r\n\r\n.singleentry table tr,.singleentry table tr:nth-of-type(odd) {\r\n    background-color: transparent !important;\r\n}\r\n\r\n.singleentry table{\r\n    margin:-10px;\r\n}\r\n\r\n\r\n.singleentry td,.singleentry th{\r\n    border-top:none !important;\r\n    padding: 5px;\r\n}", ""]);

// exports
